import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    backgroundColor: themes.light.modalBackground[1],
    width: '100%',
  },
  modalContainer: {
    width: '100%',
    backgroundColor: themes.light.white[1],
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    padding: 16,
    maxHeight: '90%',
  },
  header: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  closeIcon: {
    width: 24,
    height: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeImage: {
    width: 20,
    height: 20,
    resizeMode: 'contain',
  },
  scrollContainer: {
    height: 250, // Height to show 5 items
    overflow: 'hidden',
    position: 'relative',
  },
  yearItem: {
    height: 50,
    justifyContent: 'center',
    alignItems: 'center',
  },
  yearText: {
    fontSize: 16,
    color: themes.light.gray_blue[1],
    fontFamily: 'SF Pro Display',
  },
  highlightedYearItem: {
    color: themes.light.black[1],
  },
  highlightedYearText: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  fixedHighlight: {
    position: 'absolute',
    top: 100, // Center highlight for the middle item
    height: 50,
    width: '100%',
    borderRadius: 8,
    backgroundColor: themes.light.gray_blue[7],
    // opacity: 0.2,
    zIndex: -1,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 16,
  },
  buttonWrapper1: {
    flex: 1,
    maxWidth: '33%',
  },
  buttonWrapper2: {
    flex: 1,
    maxWidth: '67%',
  },
});
